module.exports = __webpack_public_path__ + "img/thea_pack.15ee034e.png";